require(
      "!../../node_modules/gatsby-module-loader/patch.js"
    );
    module.exports = function(cb) { return require.ensure([], function(_, error) {
        if (error) {
          console.log('bundle loading error', error)
          cb(true)
        } else {
          cb(null, function() { return require("!!../../node_modules/json-loader/index.js!./intermediate-india-foodie.json") })
        }
      }, "path---intermediate-india-foodie");
     }
    


//////////////////
// WEBPACK FOOTER
// ./~/gatsby-module-loader?name=path---intermediate-india-foodie!./.cache/json/intermediate-india-foodie.json
// module id = 715
// module chunks = 231608221292675